import { jsx, jsxs } from 'react/jsx-runtime';
import { mergeStyleSets, Panel, PanelType, Stack, Separator, ScreenWidthMaxMedium } from '@fluentui/react';
import AllPanelList from './List.esm.js';
import { useBreakpoint } from '@agoras/hooks';
import Title from './Title/Title.esm.js';
import AccountAndSettings from './AccountAndSettings/AccountAndSettings.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var classNames = mergeStyleSets({
    linkText: {
        color: 'inherit'
    },
    separator: {
        height: 36
    }
});
var panelStyles = {
    root: _define_property({}, "@media screen and (max-width: ".concat(ScreenWidthMaxMedium, "px)"), {
        marginTop: '104px'
    }),
    main: _define_property({}, "@media screen and (max-width: ".concat(ScreenWidthMaxMedium, "px)"), {
        boxShadow: 'unset',
        animation: 'none'
    })
};
var AllPanel = function(param) {
    var data = param.data, isOpen = param.isOpen, dismissPanel = param.dismissPanel, allButtonRef = param.allButtonRef;
    var _useBreakpoint = _sliced_to_array(useBreakpoint('lg', 'xxxl'), 1), isLargeAndAbove = _useBreakpoint[0];
    var dataListLength = Object.keys(data).length;
    return /*#__PURE__*/ jsx(Panel, {
        customWidth: isLargeAndAbove ? '370px' : '',
        type: isLargeAndAbove ? PanelType.customNear : PanelType.smallFluid,
        onRenderHeader: function() {
            return /*#__PURE__*/ jsx(Title, {
                dismissPanel: dismissPanel
            });
        },
        isOpen: isOpen,
        onDismiss: function(ev) {
            var _allButtonRef_current__buttonElement_current_contains, _allButtonRef_current__buttonElement_current, _allButtonRef_current__buttonElement, _allButtonRef_current;
            if (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            !(allButtonRef === null || allButtonRef === void 0 ? void 0 : (_allButtonRef_current = allButtonRef.current) === null || _allButtonRef_current === void 0 ? void 0 : (_allButtonRef_current__buttonElement = _allButtonRef_current._buttonElement) === null || _allButtonRef_current__buttonElement === void 0 ? void 0 : (_allButtonRef_current__buttonElement_current = _allButtonRef_current__buttonElement.current) === null || _allButtonRef_current__buttonElement_current === void 0 ? void 0 : (_allButtonRef_current__buttonElement_current_contains = _allButtonRef_current__buttonElement_current.contains) === null || _allButtonRef_current__buttonElement_current_contains === void 0 ? void 0 : _allButtonRef_current__buttonElement_current_contains.call(_allButtonRef_current__buttonElement_current, ev === null || ev === void 0 ? void 0 : ev.target))) {
                dismissPanel();
            }
        },
        closeButtonAriaLabel: "Close",
        isLightDismiss: true,
        isBlocking: true,
        hasCloseButton: isLargeAndAbove,
        styles: panelStyles,
        focusTrapZoneProps: {
            disabled: !isLargeAndAbove
        },
        children: /*#__PURE__*/ jsxs(Stack, {
            children: [
                /*#__PURE__*/ jsx(Separator, {}),
                Object.entries(data).map(function(param, index) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    var filtersSection = value.filtersSection, buttons = value.header.buttons;
                    return /*#__PURE__*/ jsxs(Stack, {
                        children: [
                            /*#__PURE__*/ jsx(AllPanelList, {
                                onClick: dismissPanel,
                                sectionTitle: key,
                                filtersSection: filtersSection,
                                buttons: buttons
                            }),
                            index < dataListLength - 1 ? /*#__PURE__*/ jsx(Separator, {
                                className: classNames.separator
                            }) : null
                        ]
                    }, "all-panel-".concat(key));
                }),
                /*#__PURE__*/ jsx(Separator, {
                    className: classNames.separator
                }),
                /*#__PURE__*/ jsx(AccountAndSettings, {
                    onItemClick: dismissPanel
                })
            ]
        })
    });
};

export { AllPanel as default };
